import { createReducer, on } from "@ngrx/store";
import { saveEmail } from "./user-input.actions";
import { saveCardNumbers } from "./user-input.actions";
import { CardNumbersState } from "../card-numbers/card-numbers-state";

const EMAIL_CACHE = "user-input-email";

const initialEmail: string = sessionStorage.getItem(EMAIL_CACHE) ?? "";

const initialCardNumbersState: CardNumbersState = {
  data: { bcdl: false, bcid: false, bcsc: false },
  isLoaded: false,
};

export const saveEmailReducer = createReducer(
  initialEmail,
  on(saveEmail, (state, action) => {
    // console.log(action.email)
    sessionStorage.setItem(EMAIL_CACHE, action.email);
    return action.email;
  })
);

export const cardNumbersReducer = createReducer(
  initialCardNumbersState,
  on(saveCardNumbers, (state, { response }) => ({
    data: {
      bcdl: response.bcdl,
      bcsc: response.bcsc,
      bcid: response.bcid,
    },
    isLoaded: true,
  }))
);
